export default class FullScreen {
    constructor(scene) {

        const button =  scene.add.image(760 - 16, 16, `fullscreen`, 0).setScale(1).setOrigin(1, 0).setScrollFactor(0).setInteractive();
        button.on('pointerup', function () {

            if (scene.scale.isFullscreen)
            {
                button.setFrame(0);

                scene.scale.stopFullscreen();
            }
            else
            {
                button.setFrame(1);

                scene.scale.startFullscreen();
            }

        }, scene);

        var FKey = scene.input.keyboard.addKey('F');

        FKey.on('down', function () {

            if (scene.scale.isFullscreen)
            {
                button.setFrame(0);
                scene.scale.stopFullscreen();
            }
            else
            {
                button.setFrame(1);
                scene.scale.startFullscreen();
            }

        }, scene);
            
    }
}